import { styled } from "goober";
import { useEffect, useEffectEvent, useRef } from "react";
import { Button } from "./Button";
import { SpeechRecorder } from "./SpeechRecorder";

const WaveformCanvas = styled("canvas")`
  display: block;
  width: 100%;
  height: 16px;
  border-radius: 8px;
  color: var(--text-primary);
`;

const Controls = styled("div")`
  position: absolute;
  left: 8px;
  right: 8px;
  bottom: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  pointer-events: none;
`;

const ControlGroup = styled("div")`
  display: flex;
  gap: 4px;
  align-items: center;
  pointer-events: auto;
`;

interface Props {
  leftControls?: React.ReactNode;
  onTranscript: (text: string) => void;
  onCancel: () => void;
  onSend: (text: string) => void;
}

export function VoiceRecorder({
  leftControls,
  onTranscript,
  onCancel,
  onSend,
}: Props) {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const recorder = useRef(
    new SpeechRecorder({ canvasRef, onCancel, onTranscript, onSend })
  );

  const onCancelEvent = useEffectEvent(onCancel);
  useEffect(() => {
    const rec = recorder.current;
    try {
      rec.start();
    } catch {
      onCancelEvent();
      return;
    }
    return () => rec.stop();
  }, []);

  return (
    <>
      <WaveformCanvas ref={canvasRef} />
      <Controls>
        <ControlGroup>{leftControls}</ControlGroup>
        <ControlGroup>
          <Button
            type="button"
            icon="x"
            variant="secondary"
            onClick={() => recorder.current.cancel()}
          />
          <Button
            type="button"
            icon="arrow-up"
            onClick={() => recorder.current.send()}
          />
        </ControlGroup>
      </Controls>
    </>
  );
}
